import { createSlice } from '@reduxjs/toolkit'

export const rawDataSlice = createSlice({
  name: 'rawData',
  initialState: {
    value: {}
  },
  reducers: {
    setData: (state, action) => {
      state.value = action.payload
    }
  }
})

// Action creators are generated for each case reducer function
export const { setData } = rawDataSlice.actions

export default rawDataSlice.reducer